var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6C12.5 5.44772 12.9477 5 13.5 5H21C21.5523 5 22 5.44772 22 6V13.5C22 14.0523 21.5523 14.5 21 14.5C20.4477 14.5 20 14.0523 20 13.5V8.56394L10.2359 19.1771C10.0384 19.3917 9.75703 19.5095 9.4655 19.4994C9.17397 19.4893 8.90136 19.3525 8.71913 19.1247L5.41708 14.9971L3.20711 17.2071C2.81658 17.5976 2.18342 17.5976 1.79289 17.2071C1.40237 16.8166 1.40237 16.1834 1.79289 15.7929L4.79289 12.7929C4.99402 12.5918 5.27129 12.4858 5.5553 12.5015C5.83931 12.5173 6.10318 12.6532 6.28087 12.8753L9.55297 16.9654L18.7212 7H13.5C12.9477 7 12.5 6.55228 12.5 6Z",
    fill: "#EEF2F9",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLong);
export default __webpack_public_path__ + "static/media/long.1eace162.svg";
export { ForwardRef as ReactComponent };